import React from 'react';
import Select from 'react-select';

const CustomSelect = ({ id, onChange, options, placeholder, noOptionsMessage, value, className }) => {

    const defaultValue = (options, value) => {
        return options ? options.find(option => option.value === value) : ""
    }
    return (
        <div className={className}>
            <Select
                id={id}
                value={defaultValue(options, value)}
                onChange={value => onChange(value)}
                options={options}
                placeholder={placeholder}
                defaultValue={value}
                autoFocus={true}
                noOptionsMessage={() => noOptionsMessage}
            />
        </div>
    )
}

export default CustomSelect;